import { useMutation, useQuery } from "@tanstack/react-query"

import { OnboardingResponses } from "@costory/types/endpoints/onboard"

import { apiClient } from "@costory/front/lib/apiClient"
import { queryClient } from "@costory/front/lib/queryClient"

export const useOnboardStatusQuery = (refetchInterval?: number) => {
  return useQuery({
    queryKey: ["onboardingStatus", refetchInterval],
    queryFn: async () => {
      const response =
        await apiClient.get<OnboardingResponses.Status>("/onboarding/status")
      return response.data
    },
    refetchInterval: refetchInterval ?? false,
  })
}

export const useSkipStep = () => {
  return useMutation({
    mutationFn: async (stepName: string) => {
      const response = await apiClient.post<{ success: boolean }>(
        "/onboarding/skip-step",
        {
          stepName,
        },
      )
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["onboardingStatus"] })
    },
  })
}
